import { create } from "zustand";

export const useBacktestStore = create((set) => ({
    jobId: null,
    status: 'IDLE', // IDLE, UPLOADING, PROCESSING, DONE, FAILED, CANCELLED
    progress: 0,
    stage: '',
    error: null,
    lastUpdated: null,

    setJobId: (id) => set({ jobId: id }),
    setStatus: (status) => set({ status: status }),
    setProgress: (progress) => set({ progress: progress }),
    setStage: (stage) => set({ stage: stage }),
    setError: (error) => set({ error: error }),
    setLastUpdated: (time) => set({ lastUpdated: time }),

    resetState: () => set({
        jobId: null,
        status: 'IDLE',
        progress: 0,
        stage: '',
        error: null,
        lastUpdated: null
    }),

    updateState: (newState) => set((state) => ({ ...state, ...newState })),
}));
